/**
 * @generated SignedSource<<15fb50cf7d732e3c76f821864039def2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DailyDealForm_brand$data = {
  readonly domain: string;
  readonly id: string;
  readonly shopifyConfig: {
    readonly shopifyUrl: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CDPAudienceSelectorCard_brand">;
  readonly " $fragmentType": "DailyDealForm_brand";
};
export type DailyDealForm_brand$key = {
  readonly " $data"?: DailyDealForm_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"DailyDealForm_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DailyDealForm_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandShopifyConfigType",
      "kind": "LinkedField",
      "name": "shopifyConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shopifyUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CDPAudienceSelectorCard_brand"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "7a7fa8d34ca44617323b2768cd3bfcca";

export default node;
